import React from 'react'
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaPinterestP,
  FaYoutube,
} from 'react-icons/fa'
import PropTypes from 'prop-types'

const SocialButton = ({ site, username }) => {
  const buttonValues = {}

  switch (site) {
    case 'facebook':
      buttonValues.link = `https://facebook.com/${username}/`
      buttonValues.Icon = (props) => <FaFacebookF {...props} />
      break
    case 'twitter':
      buttonValues.link = `https://twitter.com/${username}/`
      buttonValues.Icon = (props) => <FaTwitter {...props} />
      break
    case 'instagram':
      buttonValues.link = `https://instagram.com/${username}/`
      buttonValues.Icon = (props) => <FaInstagram {...props} />
      break
    case 'pinterest':
      buttonValues.link = `https://pinterest.com/${username}/`
      buttonValues.Icon = (props) => <FaPinterestP {...props} />
      break
    case 'youtube':
      buttonValues.link = username
      buttonValues.Icon = (props) => <FaYoutube {...props} />
      break
    default:
      break
  }

  const { link, Icon } = buttonValues

  if (!link || !Icon) {
    return null
  }

  return (
    <li>
      <a
        href={link}
        target="_blank"
        rel="noreferrer noopener"
        style={{
          filter:
            'brightness(0) saturate(100%) invert(14%) sepia(37%) saturate(1146%) hue-rotate(161deg) brightness(93%) contrast(104%)',
        }}
        className="flex items-center justify-center p-3 transition transform rounded-full sm:p-3.5 shadow-1 hover:shadow-4 hover:scale-101"
        aria-label={site}
      >
        <Icon className="w-5 h-5 sm:w-7 sm:h-7" />
      </a>
    </li>
  )
}

SocialButton.propTypes = {
  site: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
}

export default SocialButton
